/*
 * auth (context)
 */
import type { Session, User } from "@supabase/supabase-js"
import { createContext } from "react"

type AuthState = {
	session: Session | null
	user: User | null
	signOut: () => Promise<void>
	isLoading: boolean
}

const initialState: AuthState = {
	session: null,
	user: null,
	signOut: async () => undefined,
	isLoading: true,
}

export const AuthContext = createContext<AuthState>(initialState)
